
import { show } from '@/api/notices'
import DataForm from './components/DataForm.vue'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    DataForm
  }
})

export default class extends Vue {
  model: Record<string, any> = {}

  async created () {
    const { data } = await show(parseInt(this.$route.params.id))
    this.model = data
  }
}
